import React, { useState, useEffect } from 'react';
import { apis } from '../../services/Api';
import { getToken } from '../../services/Auth';
import './profile.css'

function Profile(props) {
    let [userDetails, setUserDetails] = useState();
    let [accountDetails, setAccountDetails] = useState([]);
    let [skillInterests, setSkillInterests] = useState([]);
    let [skillInterestsList, setSkillInterestsList] = useState([]);
    let [accountDetailsRes, setAccountDetailsRes] = useState();

    async function getUserDetails() {
        let { data } = await apis.getUser();
        setUserDetails(data);
    }

    async function getAccountDetails() {
        let { data } = await apis.getAccount();
        setAccountDetailsRes(data);
    }

    //fetch user skill interests
    const getUserSkillInterests = async (userId) => {
        let { data, included } = await apis.getUserSkillInterests(userId);
        setSkillInterests(included);

        //array to store user's skill interests
        let skillInterestList = [];

        for (let i = 0; i < included.length; i++) {
            skillInterestList.push({
                skillInterest: included[i].attributes.name
            });
        }
        setSkillInterestsList(skillInterestList);
    }

    useEffect(() => {
        async function initApiCall() {
            await getUserDetails();
            await getAccountDetails();
            await getUserSkillInterests(getToken().user_id);
        }
        initApiCall();
    }, []);

    useEffect(() => {
        //array to store interface & content lang, Timezone details
        let detailsList = {};

        if (userDetails && accountDetailsRes) {
            //find & map utcCode to timesZone code
            for (let i = 0; i < accountDetailsRes.attributes.timeZones.length; i++) {
                if (userDetails.attributes.timeZoneCode === accountDetailsRes.attributes.timeZones[i].timeZoneCode) {
                    detailsList.utcCode = accountDetailsRes.attributes.timeZones[i].utcOffsetCode;
                    break;
                }
            }
            //find & map Content Language to Content Locale code
            for (let i = 0; i < accountDetailsRes.attributes.contentLocales.length; i++) {
                if (userDetails.attributes.contentLocale === accountDetailsRes.attributes.contentLocales[i].locale) {
                    detailsList.contentLang = accountDetailsRes.attributes.contentLocales[i].name;
                    break;
                }
            }
            //find & map UI Language to Ui Locale code
            for (let i = 0; i < accountDetailsRes.attributes.uiLocales.length; i++) {
                if (userDetails.attributes.uiLocale === accountDetailsRes.attributes.uiLocales[i].locale) {
                    detailsList.uiLang = accountDetailsRes.attributes.uiLocales[i].name;
                    break;
                }
            }
            setAccountDetails(detailsList);
        }
    }, [userDetails, accountDetailsRes]);

    return (
        <>
            <div className='container'>
                <div className="profile-cta">
                    <div className="row">
                        <div className="col-4">
                            <h3>User Profile</h3>
                        </div>
                        <div className="col-8">
                            <div className="row">
                                <div className="col-7">&nbsp;</div>
                                <div className="col-5">
                                    <button className='round-cta profile-block-visibility'>Download Typescript</button>
                                    <button className='round-cta fill profile-block-visibility'>Edit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-4'>
                        <div className='profile-block'>
                            <img src={userDetails?.attributes.avatarUrl} alt='...' />
                            <div className='user-name'>
                                <span>{userDetails?.attributes.name}</span>
                            </div>
                            <div className='user-description'>
                                <p>{userDetails?.attributes.bio}</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-8'>
                        <div className='wrapper profile-content'>
                            <div className='row'>
                                <div className='col-6'><h6>Interface Language</h6></div>
                                <div className='col-6'><h6>Content Language</h6></div>
                            </div>
                            <div className='row'>
                                <div className='col-6'>{accountDetails.uiLang ? <h5>{accountDetails.uiLang}</h5> : <h5 className='default-color'>Not Selected</h5>}</div>
                                <div className='col-6'>{accountDetails.contentLang ? <h5>{accountDetails.contentLang}</h5> : <h5 className='default-color'>Not Selected</h5>}</div>
                            </div>
                            <div className='row'>
                                <div className='col-6'><h6>Timezone</h6></div>
                                <div className='col-6'><h6>Skills/Favorite topic</h6></div>
                            </div>
                            <div className='row'>
                                <div className='col-6'>{accountDetails.utcCode ? <h5>{accountDetails.utcCode}</h5> : <h5 className='default-color'>Not Selected</h5>}</div>
                                <div className='col-6'><h5>{skillInterestsList?.map((i, index) => <React.Fragment key={index}>{index ? ', ' : ''}{i.skillInterest}</React.Fragment>)}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Profile;